module.exports = __webpack_public_path__ + "static/media/B1.3c2eb1c9.jpg";